import { Box, Button, Container, Paper } from '@mui/material';
import { Subheader } from 'components';
import VideoDetails from 'features/videos/VideoDetails';
import { useAlerts, useVideos } from 'hooks';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const VideoShow = ({ ...props }) => {
	const navigate = useNavigate();
	const { id } = useParams();

	const { videoId, isLoading, isLoaded, video, findVideo } = useVideos({
		id: id
	});

	const { showAlertSuccess, showAlertError } = useAlerts();

	const handleEditClick = () => navigate(`/videos/${id}/edit`);

	useEffect(() => {
		if (id) findVideo(id);
	}, []);

	return (
		<>
			<Subheader
				title={isLoading ? 'Loading...' : `Video ${video.id}`}
				buttons={[
					<Button onClick={handleEditClick} color="primary" variant="contained">
						Edit
					</Button>
				]}
			/>
			<Container>
				<Paper>
					<Box p={4}>
						<VideoDetails video={video} />
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default VideoShow;
